export * from "ce/api/DatasourcesApi";
import { default as CE_DatasourcesApi } from "ce/api/DatasourcesApi";

class DatasourcesApi extends CE_DatasourcesApi {}

export default DatasourcesApi;
